const ProfileEnum = {
  GESTOR: '1',
  ASSISTENTE: '2',
  GERENTE_FINANCEIRO: '3',
  RELATORIO_GERAL: '4',
}
export default ProfileEnum
